<template>
    <div class="jobs">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="right searchBtn">
                            <button type="button" @click="clear"><i class="el-icon-plus"></i>添加岗位</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable jobTitleTable">
                            <tr>
                                <th style="width:66%;text-align:left;" class="left1">岗位名称</th>
                                <th style="width:10%;text-align:center;">是否开启呼叫</th>
                                <th style="width:10%;text-align:center;">展示在呼叫客户端</th>
                                <!-- <th style="width:14%">操作(隐藏、展示指的是当前是否展示在语音呼叫客户端。)</th> -->
                                <th style="width:14%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable jobConTable" :class="{overLengthTable:jobsList.length>pageSize}">
                                    <tr v-for="(item,index) in jobsList" :key="index">
                                        <td style="width:66%;text-align:left;" class="left1" v-text="item.name"></td>
                                        <td style="width:10%;text-align:center;">
                                            <!-- <div v-if="item.id" class="btnInline">
                                                <span title="是否开启呼叫" :class="item.reward?'show-yuyin':'show-yuyin not-show-yuyin'" @click="changeReward(item)">{{item.reward?"是":"否"}}</span>
                                            </div> -->
                                            <div v-if="item.id" class="btnInline">
                                                <el-switch
                                                :title="'当前岗位是否开启呼叫'"
                                                @change="changeReward(item)"
                                                v-model="item.reward"
                                                on-text=""
                                                off-text=""
                                                on-color="#51BE7E"
                                                off-color="#E06C6C">
                                                </el-switch>
                                            </div>
                                        </td>
                                        <td style="width:10%;text-align:center;">
                                            <div v-if="item.id" class="btnInline">
                                                <el-switch
                                                :title="'当前岗位是否展示在语音呼叫客户端'"
                                                @change="changeShowStatue(item)"
                                                v-model="item.show"
                                                on-text=""
                                                off-text=""
                                                on-color="#51BE7E"
                                                off-color="#E06C6C">
                                                </el-switch>
                                            </div>
                                        </td>
                                        <td style="width:14%">
                                            <div v-if="item.id" class="btnInline">
                                                <!-- <span title="是否展示" :class="item.show?'show-yuyin':'show-yuyin not-show-yuyin'" @click="changeShowStatue(item)">{{item.show?"展示":"隐藏"}}</span> -->
                                                <!-- <span title="修改" @click="getCurJob(item)"><i class="iconfont icon-bianji"></i>编辑</span> -->
                                                <span title="修改" @click="getCurJob(item)"><i class="iconfont icon-bianji" style="margin-right:10%"></i></span>
                                                <span title="删除" @click="delJob(item.id)" style="color:red"><i class="iconfont icon-icon1460188478041"></i></span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="curJobId?'修改岗位':'添加岗位'"
            :visible.sync="addJobVisible"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>名称</span>
                        <input type="text" class="left itemInput" v-model="newJob.name" placeholder="请输入岗位名称">
                    </div>
                    <div class="left msgItem clearfix groupRoles">
                        <span class="left itemName permissions"><i>*</i>选择权限</span>
                        <el-checkbox-group v-model="newJob.groupRoles">
                            <div class="rowItem rowItemDisabled">
                                <el-checkbox label="ROLE_CLERK" disabled>店员宝登录（关注公众号'店员宝'）</el-checkbox>
                            </div> 
                            <div class="rowItem">
                                <el-checkbox label="ROLE_POS">收银端登录</el-checkbox>
                            </div>
                            <div class="rowItem">
                                <el-checkbox label="ROLE_PARTNER">我的店铺（关注公众号'店员宝'-'我的店铺'</el-checkbox>
                            </div>
                            <div >
                                <span style="opacity:0">我的店铺店铺</span>
                                <span>适应于 老板/股东 查看报表）</span>
                            </div>
                            <div class="rowItem">
                                <el-checkbox label="ROLE_STOCK">库存管理权限</el-checkbox>
                            </div>
                            <div class="rowItem">
                                <el-checkbox label="ROLE_ADMIN">后台管理系统登录</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
    	data () {
    		return {
                jobsList: [], // 岗位列表
                // 新增岗位
                newJob: {
                    name:'',
                    storeId: this.curStoreId,
                    groupRoles: ['ROLE_CLERK'], //待选择权限的数组
                },
                curJobId: '', // 岗位id
                addJobVisible: false, // 控制新增弹框显示隐藏
                addJobApiBtn: true, // 控制新增岗位接口
    		}
    	},
        methods: {
            changeReward(item){
                console.log(item);
                this.$http({
                    url:"employee-groups/update-empR",
                    method:"GET",
                    params:{
                        groupId:item.id,
                        reward:!item.reward?0:1
                    }
                }).then(res=>{
                    this.getJobsList();
                });
            },
            //是否将此岗位的人员显示在语音呼叫客户端
            changeShowStatue(item){
               this.$http({
                   url:"update-show",
                   method:"GET",
                   params:{
                       id:item.id,
                       show:!item.show?0:1
                   }
               }).then(res=>{
                   console.log(res);
                   if(res.data.code == 200){
                       this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        });
                        this.getJobsList();
                   }
               }); 
            },
            // 获取岗位列表
            getJobsList: function () {
                this.$http.get('/employee-groups?storeId='+this.curStoreId).then((res)=>{
                    let body = res.data;
                    if ( body && body[0] ) {
                        this.jobsList = body;
                    }
                    let number = this.pageSize - this.jobsList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.jobsList.push({
                                name:''
                            });
                        }
                    }
                }).catch((err)=>{

                })
            },
            // 新增, 更新岗位
            addJob: function () {
                if(!this.newJob.name){
                    this.$message({
                        message: '请输入岗位名',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.curJobId ) {
                    this.curJobId = this.$uuid.create(1).hex;
                }
                if( !this.newJob.groupRoles || !this.newJob.groupRoles[0] ){
                    this.$message({
                        message: '请选择权限',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.addJobApiBtn ) {
                    return;
                }
                this.addJobApiBtn = false;
                this.$http.put('/employee-groups/'+this.curJobId, this.newJob).then((res)=>{
                    this.addJobVisible = false;
                    this.addJobApiBtn = true;
                    this.getJobsList();
                }).catch((err)=>{
                    this.addJobApiBtn = true;
                })
            },
            // 删除岗位
            delJob: function ( jobId ) {
                this.$confirm('此操作将删除该岗位, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除岗位
                    this.$http.delete('/employee-groups/'+jobId).then((res)=>{
                        this.getJobsList();
                    }).catch((err)=>{
                        
                    })
                }).catch(() => {});
            },
            // 获得当前岗位信息
            getCurJob: function ( item ) {
                console.log(item);
                this.curJobId = item.id;
                this.newJob.name = item.name;
                this.newJob.groupRoles = [];
                this.addJobVisible = true;
                this.newJob.groupRoles = JSON.parse(item.roles);
            },
            // 清除信息
            clear: function () {
                this.newJob = {
                    name:'',
                    groupRoles:['ROLE_CLERK'],
                    storeId: this.curStoreId
                }
                this.checkedCities = [];
                this.curJobId = '';
                this.addJobVisible = true;
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.jobsList.push({
                    name:''
                });
            }
        },
        activated: function () {
            this.getJobsList();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "jobs";
</style>



// WEBPACK FOOTER //
// jobs.vue?5d5b6d9e